import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './registerServiceWorker'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueEditor from "vue2-editor"
import VueMeta from 'vue-meta'
import vGoogleTranslate from 'v-google-translate';
import FullCalendar from 'vue-full-calendar'
import 'fullcalendar/dist/fullcalendar.css'
import Print from 'vue-print-nb'

Vue.use(Print)

// Alternative way to install vue-html-to-paper for Vue 2
try {
  const VueHtmlToPaper = require('vue-html-to-paper');
  
  const options = {
    name: '_blank',
    specs: [
      'fullscreen=yes',
      'titlebar=yes',
      'scrollbars=yes'
    ],
    styles: [
      'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css'
    ],
    timeout: 1000,
    autoClose: true,
    windowTitle: 'Receipt Print'
  }
  
  if (VueHtmlToPaper && VueHtmlToPaper.install) {
    Vue.use(VueHtmlToPaper, options);
  } else if (VueHtmlToPaper.default && VueHtmlToPaper.default.install) {
    Vue.use(VueHtmlToPaper.default, options);
  } else {
    console.warn('vue-html-to-paper not properly loaded');
  }
} catch (error) {
  console.error('Error loading vue-html-to-paper:', error);
}

Vue.use(FullCalendar)

Vue.use(vGoogleTranslate)
Vue.use(VueMeta)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(VueEditor)

Vue.component('v-select', vSelect)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
